import { NgModule } from '@angular/core';
import { SalonMonsterFooterComponent } from './sm-footer.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    SalonMonsterFooterComponent
  ],
  imports: [
    TranslateModule,
  ],
  exports: [
    SalonMonsterFooterComponent
  ],
  entryComponents: [],
  providers: []
})
export class SalonMonsterFooterModule {}
